import moment, { Moment } from "moment";

const parseCalendarDate = (value?: string | null): Moment | null => {
  if (!value?.trim()) {
    return null;
  }

  const date = moment.utc(value.slice(0, 10), "YYYY-MM-DD", true);

  return date.isValid() ? date : null;
};

export const formatBirthDateWithAge = (
  birthDate?: string | null,
  serviceDate?: string | null,
  deathDate?: string | null,
): string => {
  const birth = parseCalendarDate(birthDate);
  const claimDate = parseCalendarDate(serviceDate);

  if (!birth || !claimDate) {
    return "--";
  }

  const formattedBirthDate = birth.format("MM/DD/YYYY");
  const death = parseCalendarDate(deathDate);

  if (death?.isBefore(claimDate, "day")) {
    return `${formattedBirthDate} (Deceased)`;
  }

  if (birth.isAfter(claimDate, "day")) {
    return "--";
  }

  const years = claimDate.diff(birth, "years");

  if (years >= 1) {
    return `${formattedBirthDate} (Age at service: ${years})`;
  }

  const months = claimDate.diff(birth, "months");

  if (months >= 1) {
    return `${formattedBirthDate} (Age at service: ${months} month${months === 1 ? "" : "s"})`;
  }

  const days = claimDate.diff(birth, "days");

  if (days === 0) {
    return `${formattedBirthDate} (Age at service: < 1 day)`;
  }

  return `${formattedBirthDate} (Age at service: ${days} day${days === 1 ? "" : "s"})`;
};
